import AutoNumeric from "autonumeric";
import { formatPhoneNumber } from "../../../backoffice/utils";
import "../../../../stylesheets/greeting-cards";
import "../../../../stylesheets/companies";
import { addRequiredStar, checkEmailConfirmation, checkDuplicateEmails } from "../../utils";
import { validateFormData, getCurrencyFormatOptions, getNumericAmount, parseAmountString } from "../../../utils";
import { paymentMethodResponse } from "./payment_methods_response";

let receivers_count = 0;

var currency_type = window.currency_type || "clp";
$(document).ready(function () {
  let currency = currency_type;
  let main_currency = currency_type;
  let fintoc_bank = null;
  var disabled = false;

  $(".modal-img-card").click(function (event) {
    let url = this.getAttribute("data-url");
    $("#img-card-container-preview").attr("src", `${url}`);
  });

  // Card Method selector
  $(".payment-button-card").click(({ currentTarget }) => {
    const kind = currentTarget.getAttribute("data-kind");
    fintoc_bank = currentTarget.getAttribute("data-bank");
    let fintoc_status = currentTarget.getAttribute("data-status");
    currency = currentTarget.hasAttribute("data-currency")
      ? currentTarget.getAttribute("data-currency")
      : currency;
    $("#currency-type-card").val(currency);
    if (!kind) return;
    $(`input:radio[value="${kind}"]`).prop("checked", true);
    $("input:hidden.transaction_kind").val(kind);
    if (
      kind == "fintoc_payment" &&
      !fintoc_bank &&
      fintoc_status == "inactive"
    ) {
      currentTarget.style.border = "solid 2px";
      $(".fintoc-payment-button").removeClass("hidden-input");
      currentTarget.setAttribute("data-status", "active");
      $(".fintoc-arrow").css("rotate", "90deg");
    } else if (
      kind == "fintoc_payment" &&
      !fintoc_bank &&
      fintoc_status == "active"
    ) {
      currentTarget.style.border = "none";
      $(".fintoc-payment-button").addClass("hidden-input");
      currentTarget.setAttribute("data-status", "inactive");
      $(".fintoc-arrow").css("rotate", "0deg");
    } else {
      $("#new_donator_card").submit();
    }
  });

  $(document).on('input', '#dt_amount_card', function (e) {
    validateAmountToDonateCard(this)
  })

  $(document).on('click', '.currency-selector-button', function (e) {
    $("#dt_amount_card")[0].value = ''
    AutoNumeric.getAutoNumericElement('#dt_amount_card').clear();
  })

  const validateAmountToDonateCard = () => {
    currency = $("#currency-type-card")[0].value;
    const amount_donator = $("#dt_amount_card");
    const current_amount = getNumericAmount(amount_donator, currency);
    const min_clp = $(".greeting_card_amount").html();
    var min_amount = 3000;
    if (min_clp) {
      min_amount = {
        [currency]: parseAmountString(min_clp, currency),
        usd: $("#min-usd-amount").html(),
      }[currency];
    }

    if (current_amount >= min_amount) {
      $("#new_donator_card").removeClass("is-invalid");
      $("#new_donator_card").addClass("was-validated");
      $(`#amount_form_card div.invalid-feedback.payment-${currency}`).hide();
      return { valid: true, amount: current_amount };
    } else {
      $("#new_donator_card").addClass("is-invalid");
      $("#new_donator_card").removeClass("was-validated");
      $(`#amount_form_card div.invalid-feedback`).hide();
      $(`#amount_form_card div.invalid-feedback.payment-${currency}`).show();
      return { valid: false, amount: current_amount };
    }
  };

  const refreshReiceiverDisplayCount = () => {
    $(".cards-receivers .row-receiver").each(function (index) {
      $(this).find(".receiver-number").html(index + 1);
    });
  };

  //Show greeting_cards
  $(".show-type-button").click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    const category = $(this).attr("data-category");
    const page = $(this).attr("data-page");
    $(".cards-container").hide();
    $(".charity-wreaths-container").hide();
    $(`.select-card-container[data-category="${category}"]`).show();
    if (page === "1") {
      $(".page-2").css("display", "none");
      $(".page-1").css("display", "flex");
    } else {
      $(".page-1").css("display", "none");
      $(".page-2").css("display", "flex");
    }
    const title = this.dataset.title ? this.dataset.title.toLowerCase() : category.toLowerCase();
    const text =
      locale == "es"
        ? `Haz seleccionado una tarjeta de ${title}`
        : `You have selected a card of ${title}`;
    $(".card-type-title").html(text);
    $("#back-to-kind-button").attr("data-category", category);
    $("#back-to-kind-button").attr("data-page", page);
  });

  //Back greeting cards
  $(".back-button").click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    $(`.${window.donation_type}-container`).show();
    $(`.select-card-container`).hide();
  });

  $("#back-to-kind-button").on("click", function (event) {
    event.preventDefault();
    event.stopPropagation();
    const category = $(this).attr("data-category");
    const page = $(this).attr("data-page");
    $("#card-payment-container").hide();
    $(".card-container").show();
    $(`.show-type-button[data-category='${category}'][data-page='${page}']`).trigger(
      "click"
    );
  });

  $(".card-template-input").blur(function (event) {
    var input_card_data = $(this).attr("data-kind");
    if (input_card_data != "deceased_name") {
      $(`#${input_card_data.replaceAll("_", "-")}-template`)[0].innerText = this.value;
    };
    if (input_card_data == "donator_name") {
      $("#intermediate-text-template").show();
    }
    if (input_card_data == "deceased_name") {
      var category = $(this).attr("data-category");
      if (category == "Condolencias") {
        $("#intermediate-text-template")[0].innerText = `te envía esta tarjeta de condolencia por el sensible fallecimiento de ${this.value}, con el siguiente mensaje:`;
      }
      else if (category == "Corona de Caridad") {
        $("#intermediate-text-template")[0].innerText = `te envía esta corona de caridad por el sensible fallecimiento de ${this.value}, con el siguiente mensaje:`;
      }
      else {
        $("#intermediate-text-template")[0].innerText = `te envía esta tarjeta por el sensible fallecimiento de ${this.value}, con el siguiente mensaje:`;
      }
    }
  });

  //Select greeting cards
  $(".select-card-design").click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    $("#dt_greeting_card_id").val($(this).attr("data-card-id"));
    var amount = $(this).attr("data-card-amount");
    var physical_amount = $(this).attr("data-card-physical-amount");
    var usd_amount = $(this).attr("data-card-usd-amount");
    var usd_physical_amount = $(this).attr("data-card-usd-physical-amount");
    var category_deceased_fields = $(this).attr("data-card-category-deceased-fields")
    var image_url = $(this).attr("data-card-img");
    var allow_send_date = $(this).attr("data-card-allow-send-date");
    var sale_kind = $(this).attr("data-card-sale-kind");
    var category = $(this).attr("data-card-category");
    var suggested_subject = $(this).attr("data-card-suggested-subject");
    var suggested_message = $(this).attr("data-card-suggested-message");
    main_currency = $(this).attr("data-card-main-currency");
    $("#deceased_name_card").attr("data-category", category);
    $("#intermediate-text-template")[0].innerText = " te envía esta tarjeta y te manda este mensaje: "
    $(".greeting_card_amount").html(amount);
    $(".greeting_card_usd_amount").html(usd_amount);
    $("#min-amount").html(amount);
    $("#original-card-amount").html(amount);
    $("#min-usd-amount").html(usd_amount);
    $("#original-card-usd-amount").html(usd_amount);
    $(".greeting_card_digital_amount").html(amount);
    $(".greeting_card_physical_amount").html(physical_amount);
    $(".greeting_card_usd_digital_amount").html(usd_amount);
    $(".greeting_card_usd_physical_amount").html(usd_physical_amount);
    $("#sale-kind-form").hide();
    $(".addReceiver").show();
    if (sale_kind == "digital_and_physical") {
      $("#sale-kind-form").show();
    }

    if (category_deceased_fields == "true") {
      $(".condolence-field").css("display", "");
      $(".condolence-field input").prop("required", true);
      $(".condolence-field input").prop("disabled", false);
    } else {
      $(".condolence-field").css("display", "none");
      $(".condolence-field input").prop("required", false);
      $(".condolence-field input").prop("disabled", true);
    }
    confDigitalFields()
    if (sale_kind == "physical") {
      confPhysicalFields()
    } else {
      $(".physical-field").css("display", "none");
      $(".physical-field").prop("required", false);
    }
    if (usd_amount && usd_amount != "") {
      $("#currency-selection-card").show();
      $("#usd-min-amount-label").show();
    } else {
      $("#currency-selection-card").hide();
      $("#usd-min-amount-label").hide();
    }

    if (physical_amount && amount) {
      $("#physical-checkbox-container").show();
      if (sale_kind !== "digital_and_physical") {
        $(".addReceiver").hide();
      }
    } else if (sale_kind == "physical") {
      $("#subject_form_card").hide();
      $("#subject_form_card input").prop("required", false);
      $("#address_form_card").show();
      $("#commune_form_card").show();
      $("#receiver_address").prop("required", true);
      $("#receiver_commune_id").prop("required", true);
      $(".addReceiver").hide();
    }
    if (allow_send_date == "true") {
      $(".send-date-field").css("display", "");
    } else {
      $(".send-date-field").css("display", "none");
    }
    $("#card-img-container")[0].src = image_url;
    $("#card-payment-modal").modal("show");
    if ($("#card-payment-container").length > 0) {
      $("#card-payment-container").show();
      $(".card-container").hide();
      scrollPlatformContentToTop();
    }

    $("#currency-selection-card .currency-selection label").map(
      (index, label) => {
        var currency = label.getAttribute("data-currency");
        if (
          currency == main_currency ||
          (currency == "usd" && usd_amount && usd_amount != "")
        ) {
          $(label).show();
        } else {
          $(label).hide();
        }
      }
    );

    if (!AutoNumeric.getAutoNumericElement('#dt_amount_card')) {
      new AutoNumeric.multiple("#dt_amount_card", {
        ...getCurrencyFormatOptions(main_currency),
        modifyValueOnWheel: false,
      });
    }

    resetForm();
    resetPreview();
    if (sale_kind != "physical") {
      sale_kind = "digital"
    }
    resetReceivers(sale_kind);
    resetValidations();
    setSuggestions(suggested_subject, suggested_message);
    addRequiredStar();

    new AutoNumeric.multiple(".greeting_card_amount", getCurrencyFormatOptions(main_currency));
  });

  $("#greeting_card_sale_kind").on("change", function (event) {
    resetReceivers(this.value);
    resetValidations();
    const digital_usd_amount = parseFloat(
      $(".greeting_card_usd_digital_amount").html()
    );
    const physical_usd_amount = parseFloat(
      $(".greeting_card_usd_physical_amount").html()
    );
    if (this.value == "physical") {
      confPhysicalFields();
    } else {
      confDigitalFields();
    }
    new AutoNumeric.multiple(".greeting_card_amount", getCurrencyFormatOptions(main_currency));

    if (digital_usd_amount || physical_usd_amount) {
      $("#currency-selection-card").show();
      $("#usd-min-amount-label").show();
      new AutoNumeric.multiple("#usd-min-amount-label", getCurrencyFormatOptions("usd"));
    } else {
      $("#currency-selection-card").hide();
      $("#usd-min-amount-label").hide();
    }
  });

  $("#physical-checkbox").change(function (event) {
    if (this.checked) {
      $("#subject_form_card").hide();
      $("#greeting_card_sale_detail_subject").prop("required", false);
      $("#address_form_card").show();
      $("#commune_form_card").show();
      $("#receiver_address").prop("required", true);
      $("#receiver_commune_id").prop("required", true);
      $(".greeting_card_amount").html(
        $(".greeting_card_physical_amount").html()
      );
      $("#min-amount").html($(".greeting_card_physical_amount").html());
    } else {
      $("#subject_form_card").show();
      $("#greeting_card_sale_detail_subject").prop("required", true);
      $("#address_form_card").hide();
      $("#commune_form_card").hide();
      $("#receiver_address").prop("required", false);
      $("#receiver_commune_id").prop("required", false);
      $(".greeting_card_amount").html(
        $(".greeting_card_digital_amount").html()
      );
      $("#min-amount").html($(".greeting_card_digital_amount").html());
    }
    validateAmountToDonateCard();
    new AutoNumeric.multiple(".greeting_card_amount", getCurrencyFormatOptions(main_currency));
  });

  $(".addReceiver").on("click", function (e) {
    receivers_count += 1;
    e.preventDefault();
    const row = $(".cards-receivers .row-receiver").prop("outerHTML");
    $(".cards-receivers").append(
      row
        .replaceAll('data-index="0"', `data-index="${receivers_count}"`)
        .replaceAll("[0]", `[${receivers_count}]`)
        .replaceAll('id="email-3"', `id="email-${receivers_count + 3}"`)
        .replaceAll('id="email-confirmation-3"', `id="email-confirmation-${receivers_count + 3}"`)
    );
    $(
      `.cards-receivers .row-receiver[data-index="${receivers_count}"] .btn-delete`
    ).css("display", "block");
    $(
      `.cards-receivers .row-receiver[data-index="${receivers_count}"] .receiver-number`
    ).html(receivers_count + 1);
    $(".greeting_card_amount").html(
      $("#original-card-amount").html() * ($(".cards-receivers .row-receiver").length)
    );
    $(".greeting_card_usd_amount").html(
      $("#original-card-usd-amount").html() * ($(".cards-receivers .row-receiver").length)
    );
    refreshReiceiverDisplayCount();
    validateAmountToDonateCard();

    new AutoNumeric.multiple(".greeting_card_amount", getCurrencyFormatOptions(main_currency));
  });

  $(".cards-receivers").on("click", ".btn-delete", function (e) {
    e.preventDefault();
    const index = $(this).data("index");
    if (!index) return;
    $(`.row-receiver[data-index="${index}"]`).remove();
    let lastReceiver = $(".cards-receivers .row-receiver").length;
    $(".greeting_card_amount").html(
      $("#original-card-amount").html() * lastReceiver
    );
    $(".greeting_card_usd_amount").html(
      $("#original-card-usd-amount").html() * lastReceiver
    );
    refreshReiceiverDisplayCount();
    validateAmountToDonateCard();

    new AutoNumeric.multiple(".greeting_card_amount", getCurrencyFormatOptions(main_currency));
  });

  // Show card modal
  $(".show-card").click((event) => {
    event.preventDefault();
    event.stopPropagation();
    $("#image-modal .modal-body img").attr(
      "src",
      event.currentTarget.getAttribute("value")
    );
    $("#image-modal").modal("show");
  });

  // Handle card form submit
  $("#new_donator_card").submit((event) => {
    event.preventDefault();
    event.stopPropagation();
    // dentro del listener del submit
    if (disabled) return;
    disabled = true;
    setTimeout(() => {
      disabled = false;
    }, 1500);
    const form = $("#new_donator_card");

    // scoped to this form to avoid conflicts with other instances of the same checkbox on the page
    const terms_checkbox = form[0].querySelector("#terms_and_conditions_checkbox");
    if (terms_checkbox && !terms_checkbox.checked) {
      alert("Debes aceptar los términos y condiciones.");
      return;
    }

    form[0].classList.add("was-validated");
    const url = form.attr("action");
    formatPhoneNumber();

    // parse amount value, to correct format
    const amountInput = document.getElementById("dt_amount_card");
    const amount_validate = validateAmountToDonateCard(amountInput);

    amountInput.value = amount_validate.amount || "";

    var validMail = $("#donator_email_card")[0]
      ? $("#donator_email_card")[0].checkValidity()
      : false;
    if (!validMail && $("#donator_email_card")[0] === undefined)
      validMail = true;
    grecaptcha.enterprise.ready(function () {
      grecaptcha.enterprise
        .execute(recaptcha_site_key, { action: "submit" })
        .then(function (token) {
          let captcha = $(`input[name="recaptcha_token"`);
          for (var i = 0; i < captcha.length; i++) {
            captcha[i].value = token;
          }
          if (
            form[0].checkValidity() === true &&
            amount_validate.valid === true &&
            validMail === true &&
            checkEmailConfirmation() === true
          ) {
            $("#loader").show();
            $("#card-payment-modal").modal("hide");
            $.ajax({
              type: "POST",
              url: url,
              data: form.serialize(), // serializes the form's elements.
            })
              .done(function (response) {
                paymentMethodResponse(response, null, fintoc_bank);
              })
              .fail(function (response) {
                $("#loader").hide();
                alert(
                  "Ha ocurrido un problema, te pedimos por favor reintentar la transacción"
                );
                // return location.reload();
              });
            return false;
          } else {
            if (!checkDuplicateEmails()) {
              alert("Los correos de remitente y destinatarios deben ser distintos.");
            }
            console.log("Validation not going through CARD");
            console.log(
              "Form checkValidity: " +
              (form[0].checkValidity() === true).toString()
            );
            console.log(
              "TaxID not required: " + !$("#donator_tax_id").required
            );
            if (form[0].checkValidity() === false) {
              validateFormData(form[0]);
            }
          }
        });
    });
  });
});

const scrollPlatformContentToTop = () => {
  const contentContainer = document.querySelector(".platform-template .content-container");
  if (!contentContainer) return;
  contentContainer.scrollTop = 0;
  requestAnimationFrame(() => {
    contentContainer.scrollIntoView({ behavior: "smooth", block: "start" });
  });
};

const confDigitalFields = () => {
  const digital_amount = parseInt($(".greeting_card_digital_amount").html());
  const digital_usd_amount = parseFloat(
    $(".greeting_card_usd_digital_amount").html()
  );
  $("#subject_form_card").show();
  $("#subject_form_card input").prop("required", true);
  $("#address_form_card").hide();
  $("#commune_form_card").hide();
  $("#receiver_address").prop("required", false);
  $("#receiver_commune_id").prop("required", false);
  $(".addReceiver").show();
  $(".greeting_card_amount").html(digital_amount);
  $("#min-usd-amount").html(digital_usd_amount);
  const phoneNumberRequired = $("#card-payment-container #phone_number_hidden_input").attr("data-required");
  if (phoneNumberRequired == "hidden") {
    $("#card-payment-container #phone_number_form").hide();
    $("#card-payment-container #phone_number_hidden_input").prop("required", false);
    $("#card-payment-container #phone_number_hidden_input").prop("disabled", true);
  } else {
    $("#card-payment-container #phone_number_form").show();
    $("#card-payment-container #phone_number_hidden_input").prop("required", phoneNumberRequired == "required");
    $("#card-payment-container #phone_number_hidden_input").prop("disabled", false);
  }
  addRequiredStar();
}

const confPhysicalFields = () => {
  const physical_amount = parseInt(
    $(".greeting_card_physical_amount").html()
  );
  const physical_usd_amount = parseFloat(
    $(".greeting_card_usd_physical_amount").html()
  );
  $(".physical-field").css("display", "");
  $(".physical-field").prop("required", true);
  $("#subject_form_card").hide();
  $("#subject_form_card input").prop("required", false);
  $("#address_form_card").show();
  $("#commune_form_card").show();
  $("#receiver_address").prop("required", true);
  $("#receiver_commune_id").prop("required", true);
  $(".addReceiver").hide();
  $(".greeting_card_amount").html(physical_amount);
  $("#min-usd-amount").html(physical_usd_amount);
  $("#card-payment-container #phone_number_form").show();
  $("#card-payment-container #phone_number_hidden_input").prop("required", true);
  $("#card-payment-container #phone_number_hidden_input").prop("disabled", false);
  addRequiredStar();
}

const resetForm = () => {
  const form_container = $("#card-payment-container .input-container").first();
  form_container.find("input, select, textarea").each(function () {
    $(this).val("");
    if (this.id === "greeting_card_sale_kind") {
      $(this).val($(this).find("option").first().val());
    }
  });
  var subjectLabel = $("#card-payment-container label[for='greeting_card_sale_detail_subject']");
  var messageLabel = $("#card-payment-container label[for='greeting_card_sale_detail_message']");
  subjectLabel.text("Asunto del correo")
  messageLabel.text("Mensaje de la tarjeta")
  const dt_amount = $("#card-payment-container #amount_form_card");
  dt_amount.find("input").each(function () {
    $(this).val("");
  });
  AutoNumeric.getAutoNumericElement('#dt_amount_card').clear();
};

const resetReceivers = (sale_type) => {
  const receivers = $(".row-receiver");
  receivers.each(function (index, receiver) {
    if (index > 0) {
      receiver.remove();
    }
  });
  receivers_count = 0;
  const firstReceiver = receivers.first();
  firstReceiver.find("input, select, textarea").each(function () {
    $(this).val("");
  });
  if (sale_type == "digital") {
    $(".greeting_card_amount").html(parseInt($("#original-card-amount").html()));
    $(".greeting_card_usd_amount").html(parseFloat($("#original-card-usd-amount").html()));
  } else {
    $(".greeting_card_amount").html(parseInt($(".greeting_card_physical_amount").html()));
    $(".greeting_card_usd_amount").html(parseFloat($(".greeting_card_usd_physical_amount").html()));
  }
  const dt_amount = $("#card-payment-container #amount_form_card");
  dt_amount.find("input").each(function () {
    $(this).val("");
  });
  AutoNumeric.getAutoNumericElement('#dt_amount_card').clear();
};

const resetValidations = () => {
  // Remove validation error classes and messages from the form
  const form = $("#card-payment-container .input-container")
  form.find("input, select, textarea").each(function () {
    $(this).removeClass("is-valid");
    $(this).removeClass("is-invalid");
  });
  $("#new_donator_card").removeClass("was-validated");
};

const resetPreview = () => {
  let template = $(".card-msg-template");
  template.html(
    `<p>
      <span id='receiver-name-template'></span>, 
      <span id='donator-name-template'></span> <span id='donator-lastname-template'></span>
      <span id='intermediate-text-template' style='display: none'> 
        te envía esta tarjeta y te manda este mensaje: 
      </span>
    </p>`
  );
  let template_message = $("#message-template");
  template_message.html("");
};

const setSuggestions = (suggested_subject, suggested_message) => {
  var subjectInput = $("#card-payment-container #greeting_card_sale_detail_subject");
  var subjectLabel = $("#card-payment-container label[for='greeting_card_sale_detail_subject']");
  if (suggested_subject && subjectInput.length > 0) {
    subjectInput.val(suggested_subject);
    subjectLabel.text("Asunto del correo (editable)")
  }
  var messageInput = $("#card-payment-container #greeting_card_sale_detail_message");
  var messageLabel = $("#card-payment-container label[for='greeting_card_sale_detail_message']");
  if (suggested_message && messageLabel.length > 0) {
    messageInput.val(suggested_message);
    messageLabel.text("Mensaje de la tarjeta (editable)")
    messageInput.trigger("blur");
  }
}